/*@flow*/
import React from 'react';
import { value2Option, dropdownStyles } from '../utils';
import getBbox from 'lib/getBbox';
import filterByLabel from 'lib/filterByLabel';
import Select from 'react-select';
import GetCities from '../../queries/GetCities';
import nested from 'lib/nested';
import type { LocalsT } from 'lib/proforma/types';
import useCachedQuery from 'lib/useCachedQuery';
import textbox from 'lib/proforma/templates/Textbox';

const countryOpts = [
  { label: 'US', value: '-125.947266,24.607069,-66.621094,49.61071' },
  { label: 'Canada', value: '-142.03125,24.607069,-50.625,74.821934' },
];
const toOption = v => ({ label: v.name, value: v.bbox });

const Dropdown = (props: LocalsT & { bbox: ?string }) => {
  const { onChange, value } = props;
  const bbox = props.bbox || getBbox();
  const { data } = useCachedQuery(GetCities, { variables: { bbox } });
  const cityOptions = nested(data, 'cities', []).map(toOption);

  // When the 'bbox' is also the current bounding box, the label should
  // reflect that.
  let label = 'Other area';
  if (getBbox() === bbox) {
    label = 'Current Bounding Box';
  }
  // If the current bbox is not found in the city or country options,
  // it will be labeled 'Other area'. Since this is the last option in the
  // array, it won't take priority over other matches.
  const defaultOption = { label, value: bbox };

  const options = cityOptions.concat(countryOpts).concat([defaultOption]);
  const groupedOptions = [
    { label: 'City', options: cityOptions },
    { label: 'Countries', options: countryOpts },
    { label: 'Other', options: [defaultOption] },
  ];

  const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  };
  const formatGroupLabel = data2 => (
    <div style={groupStyles}>
      <span>{data2.label}</span>
    </div>
  );

  return (
    <Select
      styles={dropdownStyles}
      options={groupedOptions}
      placeholder="Current Bounding Box"
      filterOption={filterByLabel}
      value={value2Option(value, options)}
      autoComplete="off"
      cacheOptions
      defaultOptions
      isClearable
      formatGroupLabel={formatGroupLabel}
      classNamePrefix="effective-area"
      name="data-panel-effective-area"
      onChange={o => {
        if (o) {
          onChange(o.value);
        } else {
          // Use current bbox
          onChange(getBbox());
        }
      }}
    />
  );
};

export default (textbox.clone({
  Input: Dropdown,
}): any);
